import { Subscription } from '~/models/organization/subscription/Subscription'

export class SubscriptionState {
  public subscriptions: Subscription[] = []
}

export default (): SubscriptionState => new SubscriptionState()
